<template>
  <v-breadcrumbs
    :items="breadcrumbItems"
    class="breadcrumb-nav pa-0"
  >
    <template #item="{ item }">
      <v-breadcrumbs-item
        :to="item.to"
        :disabled="item.disabled"
        exact
      >
        {{ item.text }}
      </v-breadcrumbs-item>
    </template>
    <template #divider>
      <PhCaretRight :size="14" />
    </template>
  </v-breadcrumbs>
</template>

<script>
import { PhCaretRight } from 'phosphor-vue';
const BREADCRUMB_MAP = {
  '/': 'Home',
  '/dashboard': 'Dashboard',
  '/customers': 'Clientes',
  '/customers/create': 'Novo Cliente',
  '/customers/update': 'Editar Cliente',
  '/customers-authorizations': 'Fluxo Cadastral',
  '/operations': 'Operações',
  '/reports/operations/open': 'Pré-venda',
  '/reports/remittance': 'Remessas Internacionais',
  '/reports/remittance/management': 'Lucro / Remessas',
  '/exchange-closing': 'Fechamento de câmbio',
  '/operations/:id/detail': 'Detalhe da Operação',
  '/reports/exchange': 'Câmbio Turismo',
  '/reports/stablecoin/remittance': 'Remessas Stablecoin',
  '/reports/stablecoin/management': 'Lucro Stablecoin',
  '/reports/import-data/management': 'Gestão de DUIMP/DU-E',
  '/correspondents': 'Corban',
  '/operations/commissions': 'Comissões',
  '/registrations/operation-natures': 'Naturezas de Operação',
  '/registrations/banks': 'Bancos',
  '/registrations/currencies': 'Spread / Moedas',
  '/registrations/payment-methods': 'Métodos de Pagamento',
  '/registrations/rate-apis': 'APIs de Cotação',
  '/registrations/templates': 'Templates',
  '/registrations/currency-holidays': 'Feriados',
  '/registrations/templates/select-type': 'Novo Template',
  '/registrations/templates/create': 'Cadastro de Template',
  '/users': 'Usuários',
  '/profiles': 'Perfis',
  '/audit': 'Auditoria',
  '/configuration': 'Configurações',
  '/notifications': 'Notificações',
  '/logs/email': 'E-mails Enviados',
  '/logs/whatsapp': 'Mensagens WhatsApp',
  '/whatsapp-inbox': 'WhatsApp',
  '/customer-access': 'Home',
  '/customer-access/operations': 'Nova Operação',
  '/customer-access/operation-report': 'Minhas Operações',
  '/customer-access/account': 'Minha Conta'
};

export default {
  name: 'BreadcrumbNav',
  components: {
    PhCaretRight
  },
  data() {
    return {
      dynamicLabel: ''
    };
  },
  mounted() {
    this.$eventBus.$on('breadcrumb-dynamic-label', this.onDynamicLabel);
  },
  beforeDestroy() {
    this.$eventBus.$off('breadcrumb-dynamic-label', this.onDynamicLabel);
  },
  computed: {
    breadcrumbItems() {
      const routeName = this.$route.name;
      const currentPath = this.$route.path;
      const items = [];

      if (routeName === 'FormEditCustomer') {
        items.push({ text: 'Clientes', to: '/customers', disabled: false });
        items.push({
          text: this.dynamicLabel || 'Editar Cliente',
          to: currentPath,
          disabled: true
        });

        return items;
      }

      if (routeName === 'FormCreateCustomer') {
        items.push({ text: 'Clientes', to: '/customers', disabled: false });
        items.push({ text: 'Novo Cliente', to: currentPath, disabled: true });

        return items;
      }

      if (
        routeName === 'FormEditCorrespondent' ||
        routeName === 'FormEditCorrespondentExternalAcess'
      ) {
        items.push({ text: 'Corban', to: '/correspondents', disabled: false });
        items.push({
          text: this.dynamicLabel || 'Editar Corban',
          to: currentPath,
          disabled: true
        });

        return items;
      }

      if (routeName === 'FormCreateCorrespondent') {
        items.push({ text: 'Corban', to: '/correspondents', disabled: false });
        items.push({ text: 'Novo Corban', to: currentPath, disabled: true });

        return items;
      }

      if (routeName === 'FormAuthorizationCustomer') {
        items.push({ text: 'Fluxo Cadastral', to: '/customers-authorizations', disabled: false });
        items.push({
          text: this.dynamicLabel || 'Autorização',
          to: currentPath,
          disabled: true
        });

        return items;
      }

      if (routeName === 'CustomerAccessOperationDetail') {
        items.push({ text: 'Minhas Operações', to: '/customer-access/operation-report', disabled: false });
        items.push({
          text: this.dynamicLabel || 'Detalhe da Operação',
          to: currentPath,
          disabled: true
        });

        return items;
      }

      if (routeName === 'ExchangeFormEditBank') {
        items.push({ text: 'Bancos', to: '/registrations/banks', disabled: false });
        items.push({
          text: this.dynamicLabel || 'Editar Banco',
          to: currentPath,
          disabled: true
        });

        return items;
      }

      if (routeName === 'ExchangeFormCreateBank') {
        items.push({ text: 'Bancos', to: '/registrations/banks', disabled: false });
        items.push({ text: 'Novo Banco', to: currentPath, disabled: true });

        return items;
      }

      if (routeName === 'FormTemplate') {
        items.push({ text: 'Templates', to: '/registrations/templates', disabled: false });
        items.push({ text: 'Novo Template', to: currentPath, disabled: true });

        return items;
      }

      if (routeName === 'FormEditTemplate') {
        items.push({ text: 'Templates', to: '/registrations/templates', disabled: false });
        items.push({ text: 'Editar Template', to: currentPath, disabled: true });

        return items;
      }

      if (routeName === 'TemplateTypeSelector') {
        items.push({ text: 'Templates', to: '/registrations/templates', disabled: false });
        items.push({ text: 'Novo Template', to: currentPath, disabled: true });

        return items;
      }

      const matched = this.$route.matched;

      matched.forEach((record, index) => {
        if (record.path === '/' || record.path === '') return;

        const isLast = index === matched.length - 1;
        const path = record.path;
        const text = BREADCRUMB_MAP[path] || record.name || path;

        items.push({ text, to: path, disabled: isLast });
      });

      if (items.length === 0 && currentPath !== '/') {
        const text = BREADCRUMB_MAP[currentPath] || routeName || currentPath;

        items.push({ text, to: currentPath, disabled: true });
      }

      return items;
    }
  },
  methods: {
    onDynamicLabel(label) {
      this.dynamicLabel = label || '';
    }
  }
};
</script>

<style lang="scss">
/* Mesma tipografia dos títulos de tela (a fonte de display do DS): a trilha é o
   nome da página no topo, não um texto de apoio. */
.breadcrumb-nav {
  font-family: var(--tc-font-display);
  font-size: var(--tc-fs-h3);

  .v-breadcrumbs__item {
    color: var(--v-primary-base) !important;
    font-family: var(--tc-font-display);
    font-size: var(--tc-fs-h3);
    font-weight: var(--tc-fw-semibold);
    letter-spacing: var(--tc-tracking-snug);
    line-height: var(--tc-lh-tight);

    &--disabled {
      color: var(--v-primary-base) !important;
    }
  }

  .v-breadcrumbs__divider {
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.6);
    padding: 0 4px;
  }
}

/* No celular o último item é o nome do registro aberto, e nome de empresa não
   é curto. Sem limite ele quebra em três linhas e a trilha passa da altura da
   barra, empurrando o conteúdo da tela para baixo. Uma linha só, cortada no
   fim: o nome inteiro continua no cabeçalho do registro, logo abaixo. */
@media (max-width: 599px) {
  /* `.v-breadcrumbs` no seletor para empatar em especificidade com a regra do
     Vuetify que declara `flex-wrap: wrap` — sem isso a ordem dos arquivos
     decide, e a do Vuetify vem depois. */
  .v-breadcrumbs.breadcrumb-nav {
    flex-wrap: nowrap;
    /* Fica com o espaço que sobra na barra em vez de encolher junto com os
       ícones da direita: com `0 1 auto` a trilha caía para 17px e os três itens
       empilhavam, passando da altura da barra. */
    flex: 1 1 auto;
    min-width: 0;

    li {
      min-width: 0;
    }

    .v-breadcrumbs__item {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.theme--dark .breadcrumb-nav {
  .v-breadcrumbs__item {
    color: var(--v-primary-lighten2);

    &--disabled {
      color: var(--v-primary-lighten2);
    }
  }

  .v-breadcrumbs__divider {
    color: rgba(255, 255, 255, 0.5);
  }
}
</style>
